import { ref, onMounted, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { Tokens } from '@Utilities/enum'

import _ from "lodash";
export default function useAnalytics () {

    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const attribute = ref()
    const dimension = ref();
    const slug = ref();
    const type = ref();
    const currentRoute = ref(router.currentRoute.value);
    const aggregationType = ref();
    const aggregationTable = ref();
    const page = ref();
    const currentSection = ref();
    const sort = ref();

    const isLoading = computed(() => {
        return store.getters["Analytics/isLoading"];
    });

    const isLoadingMore = computed(() => {
        return store.getters["Analytics/isLoadingMore"];
    });

    const export_url = computed(() => {
        return store.getters["Analytics/exportUrl"];
    });

    const analyticsData = computed(() => {
        return store.getters["Analytics/analyticsData"];
    });

    const analyticsParams = computed(() => {
        return store.getters["Analytics/savedParams"];
    });

    const adminAnalyticsData = computed(() => {
        return store.getters["Analytics/adminAnalyticsData"];
    });

    const adminAnalyticsParams = computed(() => {
        return store.getters["Analytics/adminSavedParams"];
    });

    const aggregationTableData = computed(() => {
        return store.getters["Analytics/aggregationTableData"]
    })

    onMounted(() => {
        setupData();
    });

    const setupData = (async () => {
        currentRoute.value = router.currentRoute.value;
        const routeParams = currentRoute.value.params;
        const queryParams = currentRoute.value.query
        attribute.value = routeParams.attribute;
        dimension.value = routeParams.dimension;
        aggregationType.value = routeParams.type;
        aggregationTable.value = routeParams.aggregation
        slug.value = queryParams.slug;
        page.value = queryParams.page;
        sort.value = queryParams.sort;
        type.value = routeParams.type;
        const menuNav = await store.dispatch("Cookies/onGetCookies", Tokens.MenuNav)
        currentSection.value = !_.isEmpty(menuNav) ? menuNav.item : ''

    })

    const selectedSection = computed(() => {
        // currentSection.value
        let section = {};
        _.forEach(currentSection.value, (sect) => {
            if (sect.slug === slug.value) {
                section = sect
            }
        })

        return section
    })

    const getAnalytics = async (request_type = null) => {
        setupData();
        const metric_type = request_type ? request_type : type.value;

        const params = {
            dimension: dimension.value,
            attribute: attribute.value,
            type: metric_type,
            slug: slug.value,
            sort: sort.value,
        };

        if ("level3" in currentSection.value && metric_type === 'brand' && route?.query?.sub_class) {
            params.sub_class = route?.query?.sub_class
        }

        await store.dispatch("Analytics/getAnalytics", params);
    }
    const getAdminAnalytics = async () => {
        if (!_.isEmpty(currentSection.value)) {

            const params = {
                type: aggregationType.value,
                page: page.value,
            };

            await store.dispatch("Analytics/getAdminAnalytics", params);
        }
    }

    const getAnalyticsByTable = async () => {
        if (!_.isEmpty(currentSection.value)) {
            const params = {
                type: aggregationType.value,
                aggregation: aggregationTable.value,
                slug: slug.value,
            };

            await store.dispatch("Analytics/getAnalyticsByTable", params);
        }
    }

    return {
        getAnalytics,
        getAdminAnalytics,
        getAnalyticsByTable,
        setupData,
        selectedSection,
        store,
        router,
        export_url,
        analyticsParams,
        analyticsData,
        adminAnalyticsParams,
        aggregationTableData,
        aggregationTable,
        adminAnalyticsData,
        isLoading,
        isLoadingMore,
        currentRoute,
        attribute,
        dimension,
        slug,
        sort,
        type,
        currentSection
    }

}
